import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';
import { uploadFileFailed, uploadFileSuccessful } from '../actions';

export default function* uploadFile(action) {
  try {
    const formData = action.payload;
    const url = `${BACKEND_URL}/resources/media-files`;
    const headers = {
      Accept: 'multipart/form-data',
      'Content-Type': 'multipart/form-data',
    };

    const dataResponse = yield makeRequest(url, formData, action, 'POST', true, headers, true);
    if (dataResponse.status === CREATED) {
      const data = yield dataResponse.json();
      yield put(uploadFileSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(uploadFileFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(uploadFileFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
